// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"169":"038a6b1b","198":"191237fc","447":"14e7a65c","488":"680d2ff5","550":"eb5111d2"}[chunkId] + ".chunk.js";
};